import { render, staticRenderFns } from "./RotateSquare3.vue?vue&type=template&id=5fe1893f&scoped=true&"
import script from "./RotateSquare3.vue?vue&type=script&lang=js&"
export * from "./RotateSquare3.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare3.vue?vue&type=style&index=0&id=5fe1893f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1893f",
  null
  
)

export default component.exports